import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {onAuthStateChanged} from 'firebase/auth';
import {logger, ProfileService, TranslateHelperService} from '@services';
import {FirebaseInitService} from '../services/shared/firebase-init.service';

const toPath = (segments: string[]): string => {
	if (!segments || segments.length === 0) {
		return '/';
	}
	return `/${segments.filter(Boolean).join('/')}`;
};

export const adminGuard: CanActivateFn = () => {
	const firebaseInit = inject(FirebaseInitService);
	const router = inject(Router);
	const translateService = inject(TranslateHelperService);
	const profileService = inject(ProfileService);
	const auth = firebaseInit.auth;

	return new Promise<boolean>((resolve) => {
		const unsubscribe = onAuthStateChanged(
			auth,
			async (user) => {
				if (!user) {
					router.navigateByUrl(translateService.localize('/'));
					resolve(false);
					unsubscribe();
					return;
				}

				const currentProfile = profileService.profile();
				const profile = currentProfile?.uuid === user.uid
					? currentProfile
					: await profileService.getProfileByUid(user.uid);

				if (profile?.scope === 'Admin') {
					resolve(true);
				} else {
					router.navigateByUrl(translateService.localize(toPath(['app', 'home'])));
					resolve(false);
				}
				unsubscribe();
			},
			(error) => {
				logger.error('Admin guard error:', error);
				router.navigateByUrl(translateService.localize('/'));
				resolve(false);
				unsubscribe();
			}
		);
	});
};
